export const newly_added = {
  all_links: [
    {
      link: "https://csvidyalaya.com/DBMS/dbms_topic.html",
      name: "Dbms topic",
    },
    {
      link: "https://csvidyalaya.com/DBMS/how_we_install_mysql_2025.html",
      name: "how to install mysql",
    },
    {
      link: "https://csvidyalaya.com/DBMS/DBMS_topics/Relational_algebra_topics.html",
      name: "relational algebra Topics",
    },
    {
      link: "https://csvidyalaya.com/Operating-system/Disk_scheduling/disk_scheduling_algorithms.html",
      name: "Disks cheduling question",
    },
    {
      link: "https://csvidyalaya.com/DBMS/DBMS_topics/relational_algebra_relational_calculus.html",
      name: "relational algebra + relational calculus",
    },
    {
      link: "https://csvidyalaya.com/DBMS/DBMS_topics/relational_calculus/tuple_relational_calculus.html",
      name: "tuple relational calculus",
    },
    {
      link: "https://csvidyalaya.com/DBMS/DBMS_topics/relational_algebra/relational_algebra_question.html",
      name: "relational algebra question",
    },
  ],
};

export const upcoming = {
  all_links: [
    {
      link: "#",
      name: "software engineering",
    },
    {
      link: "#",
      name: "testing",
    },
    {
      link: "#",
      name: "black box testing",
    },
    {
      link: "#",
      name: "white box testing",
    },
    {
      link: "#",
      name: "path testing question",
    },
    {
      link: "#",
      name: "boundary value analysis question",
    }
  ],
};


